module.exports = __webpack_public_path__ + "static/media/example-1.5a0f942e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Dalyellup/example-1.jpg
// module id = 232
// module chunks = 0